import i18n from '@/plugins/i18n';

export const tooltip = {
  mounted(el, binding) {
    // Create mouseenter event handler
    el.handleMouseEnter = () => {
        if (!binding.value) return;

      // Create tooltip element only on hover
      const tooltip = document.createElement('div');
      
      // Set content with i18n
      tooltip.textContent = i18n.global.t(binding.value);
      
      // Position absolutely with no styling
      tooltip.style.position = 'fixed';
      tooltip.style.zIndex = '1000';
      
      // Calculate position relative to hovered element
      const rect = el.getBoundingClientRect();
      
      // Determine position (can be customized via binding.arg: 'top', 'right', 'bottom', 'left')
      const position = binding.arg || 'top';

      tooltip.classList.add('tooltip-type-1');
      tooltip.classList.add('tooltip-' + position);
      
      // Position the tooltip based on the specified position
      switch(position) {
        case 'top':
          tooltip.style.bottom = `${window.innerHeight - rect.top + 8}px`;
          tooltip.style.left = `${rect.left + rect.width/2}px`;
          tooltip.style.transform = 'translateX(-50%)';
          break;
        case 'right':
          tooltip.style.left = `${rect.right + 8}px`;
          tooltip.style.top = `${rect.top + rect.height/2}px`;
          tooltip.style.transform = 'translateY(-50%)';
          break;
        case 'left':
          tooltip.style.right = `${window.innerWidth - rect.left + 8}px`;
          tooltip.style.top = `${rect.top + rect.height/2}px`;
          tooltip.style.transform = 'translateY(-50%)';
          break;
        case 'bottom':
        default:
          tooltip.style.top = `${rect.bottom + 8}px`;
          tooltip.style.left = `${rect.left + rect.width/2}px`;
          tooltip.style.transform = 'translateX(-50%)';
          break;
      }
      
      // Add to DOM
      document.body.appendChild(tooltip);
      
      // Store reference for cleanup
      el._tooltip = tooltip;
    };
    
    // Create mouseleave event handler
    el.handleMouseLeave = () => {
      // Remove tooltip from DOM when not hovering
      if (el._tooltip) {
        document.body.removeChild(el._tooltip);
        delete el._tooltip;
      }
    };
    
    // Add event listeners
    el.addEventListener('mouseenter', el.handleMouseEnter);
    el.addEventListener('mouseleave', el.handleMouseLeave);
  },
  
  unmounted(el) {
    // Clean up event listeners
    el.removeEventListener('mouseenter', el.handleMouseEnter);
    el.removeEventListener('mouseleave', el.handleMouseLeave);
    
    // Clean up tooltip if it exists
    if (el._tooltip && document.body.contains(el._tooltip)) {
      document.body.removeChild(el._tooltip);
    }
  }
};